module.exports = __webpack_public_path__ + "6d3140cf41d5f55523aefc3bdd6b454a.svg";